import { Country } from '~/Api/Country';
import { Error, ErrorCode } from '~/Api/User/ProductGroup/SiMaxPrice/Error';
import { ApiClientError } from '~/ApiClient';

export const mapError = (error: ApiClientError): Error => {
	const errorCode = error.code as ErrorCode;
	const { product, duplicateCountries } = (error.meta ?? {}) as {
		product?: { id: string };
		duplicateCountries?: { alpha2: string; name: string }[];
	};

	return new Error(
		errorCode,
		product?.id ?? null,
		duplicateCountries?.map((country) => new Country(country.alpha2, country.name)) ?? []
	);
};
